<template>
  <div class="hy-piao">
    <div class="title">
      <h5>申请发票 <span @click="goNumber">共{{piao_data.length}}张 <b>申请开多张发票  <span class="iconfont">&#xe699;</span></b></span></h5>
    </div>
    <div class="getinvoke" v-if="iswx">
      <van-button type="primary" @click="getinvoke">获取微信发票抬头</van-button>
    </div>
    <div class="typelist">
      <!-- 循环字段-->
      <div v-for="(items,index) in typelist" :key="index">
        <!-- 文本输入框-->
        <van-field v-if="items.type == 1 && items.isShow" v-model="checkbox[items.name]" :label="items.title + '：'" :placeholder="items.placeholder+(items.isRequired ?  '(必填)':'(非必填)')" :maxlength="100" @blur="validator(index)" :readonly="items.disabled"/>
        <!-- 单选框 -->
        <div class="van-radio-groupBox" v-else-if="items.type == 2 && items.isShow">
          <h5>{{items.title}}：</h5>
          <van-radio-group v-model="checkbox[items.name]" direction="horizontal" @change="changeRadio(items.name)">
            <!--循环单选框-->
            <van-radio :name="val.value" v-for="val in items.options" :disabled="!val.check" >{{val.text}}</van-radio>
          </van-radio-group>
        </div>
        <!--下拉选择-->
        <div class="van-select-groupbox" v-else-if="items.type == 3 && items.isShow">
          <div class="van-select-label">
            {{items.title}}：
          </div>
          <van-dropdown-menu>
            <van-dropdown-item v-model="checkbox[items.name]" :title="checkbox[items.name] == '' ? '请选择':items.options[checkbox[items.name]]" :options="items.options">
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
    </div>
    <div class="addPiaoBtnbox" >
      <router-link class="link" to="/myInvoice">返回</router-link>
      <span class="addPiaoBtn" @click="addPiaoBtn"> 提交 </span>
     </div>
  </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        code: '',
        order_no: '',
        typelist: [
          {
            type: 2, //1 输入框 2 单选 3 下拉
            title: '发票类型',
            name:'invoice_type',
            isShow: false,
            isRequired: true,
            reg: '',
            options: [ 
              {
                text: '增值税电子普通发票',
                value: 3,
                check: true
              },
              {
                text: '增值税电子专用发票',
                value: 4,
                check: true
              },
              {
                text: '增值税专用发票',
                value: 2,
                check: true
              },
              {
                text: '增值税普通发票',
                value: 1,
                check: true
              },
            ]
          },
          {
            type: 2, //1 输入框 2 单选 3 下拉
            title: '配送方式',
            name:'get_type',
            isRequired: true,
            isShow: false,
            reg: '',
            options: [{
                text: '现场领取',
                value: 1,
                check: true
              },
              {
                text: '发票邮寄',
                value: 2,
                check: true
              }
            ]
          },
          {
            type: 2, //1 输入框 2 单选 3 下拉
            title: '抬头类型',
            name:'type',
            isShow: false,
            isRequired: true,
            reg: '',
            options: [{
                text: '企业',
                value: 2,
                check: true
              },
              {
                text: '个人',
                value: 1,
                check: true
              }
            ]
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '发票抬头',
            name:'title',
            disabled: false,
            isShow: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写发票抬头',
            options: []
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '税号',
            name:'tax_no',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$',
            placeholder: '请填写纳税人识别号',
            options: []
          },
          {
            type: 3, //1 输入框 2 单选 3 下拉
            title: '发票项目',
            name:'invoice_project',
            isShow: false,
            isRequired: true,
            reg: '',
            options: [{
              text: '会议费',
              value: 2,
              check: true
            }, ]
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '开户银行',
            name:'bank_name',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写开户银行',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '银行账号',
            name:'bank_no',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写账号',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '公司电话',
            name:'tel',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写电话',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '公司地址',
            name:'cmp_address',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写地址',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '可开票总金额',
            name:'price',
            isShow: false,
            disabled: true,
            isRequired: true,
            reg: '',
            placeholder: '',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '电子邮箱',
            name:'email',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$',
            placeholder: '请填写电子邮箱',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '收件人',
            name:'name',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写收件人',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '联系电话',
            name:'phone',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写联系电话',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '详细地址',
            name:'address',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写地址',
          },
        ],
        checkbox: {
          price: '', //开票金额
          invoice_project:2, //发票项目
          type: 2, //1:个人 2:企业
          invoice_type: 3, //1纸质普通发票 2纸质专用发票 3电子普通发票 4电子专票
          title: '', //	发票抬头
          tax_no: '', //税号type为1个人可以为空
          cmp_address: '', //公司地址(专票必须)
          tel: '', //	公司电话(专票必须)
          bank_name: '', //	开户银行(专票必须)
          bank_no: '', //	银行账号(专票必须)
          name: '', //	收件人姓名(纸质必须)
          address: '', //	收件地址(纸质必须)
          phone: '', //	收件人手机(纸质必须)
          email: '', //	邮件地址(电子必须)
          order_no: '', //	关联订单号(多个","隔开)
          get_type: 2, //	纸质发票领取方式，1：现场领取，2：发票邮寄
          dep_code: '', //	部门编码
          conference_code:''//会议编码
        },
        box:[
          [0,1,2,3,4,5,10,12,13,14],//纸质普票
          [0,1,2,3,4,5,6,7,8,9,10,12,13,14],//纸质专票
          [0,2,3,4,5,10,11],//电子发票
          [0,2,3,4,5,6,7,8,9,10,11],//电子专发票
        ],
        piao_data:[
          {
            num:'',
            btn:false
          }
        ],
        wxbox:'',
        iswx:false
      };
    },
    created: function() {
      var _this = this;
      var local = JSON.parse(localStorage.getItem('invoiceMenu'));
      _this.checkbox.code = local?.code;
      _this.checkbox.price = local?.allAmount;
      _this.checkbox.order_no = local?.order_no;
      _this.checkbox.dep_code = local?.dep_code;
      _this.checkbox.conference_code = local?.code;
      _this.piao_data[0].num =  local?.allAmount;
      this.getinvoicetype({
        conference_code: local?.code
      }).then(res => {
        this.typelist[0].options = this.typelist[0].options.filter(i => res.posts.invoice_type.map(j => Number(j)).includes(i.value))
      })
      var piao_data = JSON.parse(localStorage.getItem('piao_data'));
      if(piao_data){
        _this.piao_data = piao_data;
      }
      var piao_checkbox = JSON.parse(localStorage.getItem('piao_checkbox'));
      if(piao_checkbox){
        _this.checkbox = piao_checkbox;
        localStorage.removeItem('piao_checkbox');
      }
      var wx_box = JSON.parse(localStorage.getItem('wx_box'));
      if(wx_box){
        _this.wxbox = wx_box;
        localStorage.removeItem('wx_box');
      }
      _this.changeRadio('invoice_type');
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        _this.iswx = true;
      }
    },
    methods: {
      getinvoicetype(params){
        let api_url = '/ac1/conference/getinvoicetype'
        return this.$get(api_url, params)
      },
      getinvoke(){
        var _this = this;
        _this.$WXConfig.wxInvoke({
          that: _this,
        },function(res){
          var boxs = JSON.parse(res.choose_invoice_title_info);
          _this.addWxbox(boxs);
          _this.wxbox = boxs;
        });
      },
      addWxbox(boxs){
        var _this = this;
        _this.checkbox.title = boxs.title;
        _this.checkbox.bank_name = boxs.bankName;
        _this.checkbox.bank_no = (boxs.bankAccount).replace(/\s*/g,"");;
        _this.checkbox.tax_no = (boxs.taxNumber).replace(/\s*/g,"");
        _this.checkbox.cmp_address = boxs.companyAddress;
        _this.checkbox.tel = boxs.telephone;
      },
      changeRadio(text){
        var _this = this;
        if(text == 'invoice_type'){
          var radioN  = _this.checkbox.invoice_type;
          for(var i=0;i<_this.typelist.length;i++){
            _this.typelist[i].isShow = false;
            _this.checkbox.cmp_address = '';
            _this.checkbox.tel = '';
            _this.checkbox.bank_name = '';
            _this.checkbox.bank_no = '';
            if(_this.wxbox != ''){
              _this.addWxbox(_this.wxbox);
            }
            _this.typelist[2].options = [
              {
                text: '企业',
                value: 2,
                check: true
              },
              {
                text: '个人',
                value: 1,
                check: true
              }
            ];
            _this.checkbox.type = 2;
              if(radioN == 4){
              if(_this.box[3].indexOf(i) != -1){
                _this.typelist[i].isShow = true;
               }
              _this.checkbox.get_type = 2;
            }else if(radioN == 3){
              if(_this.box[2].indexOf(i) != -1){
                _this.typelist[i].isShow = true;
               }
              _this.checkbox.get_type = 2;
            }else if(radioN == 1){
              if(_this.box[0].indexOf(i) != -1){
                _this.typelist[i].isShow = true;
              }
               _this.checkbox.get_type = 2;
            }else if(radioN == 2){
              if(_this.box[1].indexOf(i) != -1){
                _this.typelist[i].isShow = true;
                _this.checkbox.type = 2;
                _this.typelist[2].options = [
                  {
                    text: '企业',
                    value: 2,
                    check: true
                  }
                ]
              }
           //   _this.checkbox.get_type = 1;
            }
          }
        }
        if(text == 'type'){
          if(_this.checkbox.type == 1){
            _this.typelist[4].isRequired = false;
          }else{
            _this.typelist[4].isRequired = true;
          }
        }
      },
      // 校验函数返回 true 表示校验通过，false 表示不通过
      validator(i) {

        var _this = this;
        var car_filed = _this.typelist[i];
        var regular = new RegExp(car_filed.reg);
        if(car_filed.isRequired){
          if(_this.checkbox[car_filed.name] != ''){
            if(car_filed.reg != ''){
              if(!(regular.test(_this.checkbox[car_filed.name]))){
                _this.$toast(car_filed.title+'错误！');
                return false;
              }
            }
          }else{
            _this.$toast(car_filed.title+'不能为空！');
            return false;
          }
        }
      },
      //提交开票信息
      addPiaoBtn(){
        var _this = this,status = true,each_amount='';
        for(var i = 0;i<_this.typelist.length;i++){
          var boxs = _this.box[_this.checkbox.invoice_type - 1];
          if(status){
            if(boxs.indexOf(i) != -1){
              var car_filed = _this.typelist[i];
              if(car_filed.type == 1){
                var regular = new RegExp(car_filed.reg);
                if(car_filed.isRequired){
                  if(_this.checkbox[car_filed.name] != ''){
                    if(car_filed.reg != ''){
                      if(!(regular.test(_this.checkbox[car_filed.name]))){
                        _this.$toast(car_filed.title+'错误！');
                        status =  false;
                      }
                    }
                  }else{
                    _this.$toast(car_filed.title+'不能为空！');
                    status = false;
                  }
                }
              } else if(car_filed.type == 2 || car_filed.type == 3){
                if(_this.checkbox[car_filed.name] == ''){
                  _this.$toast('请选择'+car_filed.title+'！');
                  status = false;
                }
              }
            }
          }
        };
        for(var s =0;s<_this.piao_data.length;s++){
          each_amount+=','+_this.piao_data[s].num;
        }
        if(status){
          let url = "/ac1/conference/invoice/add";
          let params = {
            invoice_project: _this.checkbox.invoice_project,
            type: _this.checkbox.type,
            invoice_type: _this.checkbox.invoice_type,
            title: _this.checkbox.title,
            tax_no: _this.checkbox.tax_no,
            cmp_address: _this.checkbox.cmp_address,
            tel: _this.checkbox.tel,
            bank_name: _this.checkbox.bank_name,
            bank_no: _this.checkbox.bank_no,
            name: _this.checkbox.name,
            address: _this.checkbox.address,
            phone: _this.checkbox.phone,
            email: _this.checkbox.email,
            order_no: _this.checkbox?.order_no,
            get_type: _this.checkbox?.get_type,
            dep_code: _this.checkbox?.dep_code,
            conference_code: _this.checkbox.conference_code,
            is_each:_this.piao_data.length > 1 ? '1':'0',
            need_num:_this.piao_data.length,
            each_amount:each_amount.substr(1)
          };
          _this.$post(url, params).then(res => {
            if (res.code == "1") {
              _this.$toast('提交申请成功！');
              setTimeout(function(){
                localStorage.removeItem('piao_data');
                localStorage.removeItem('piao_checkbox');
                _this.$router.push('/invoiceList');
              },1000)
            }else{
              _this.$toast(res.msg);
            }
          },function(res){
            console.log(res.msg);
          });
        }
      },
      goNumber(){
        var _this = this;
        localStorage.setItem('piao_checkbox',JSON.stringify(_this.checkbox));
        localStorage.setItem('wx_box',JSON.stringify(_this.wxbox));
        _this.$router.push('/invoiceNum');
      }
    },
    mounted() {},
    beforeDestroy(){
      var _this = this;
      _this.$toast.clear();
      localStorage.removeItem('piao_data');
    }
  }
</script>
<style lang="less">
  .hy-piao {
    width: 100%;
    min-height: 100vh;
    background: #F7F7F7;
    overflow: hidden;
    .title {
      width: 100%;
      padding: 35px 30px;
      overflow: hidden;
      line-height: 35px;
      margin-bottom: 20px;
      background: #FFF;
      h5 {
        float: left;
        font-size: 30px;
        color: #333;
        font-weight: 600;
        border-left: 6px solid #0098f9;
        padding-left: 5px;
        line-height: 35px;
        overflow: hidden;
        width: 100%;
        >span{
          float: right;
          font-weight: 400;
          font-size: 26px;
          b{
            font-weight: 400;
            color: #ff0000;
          }
        }
      }
    }
    .getinvoke{
      width:100%;
      padding: 0 30px;
      button{
        width: 100%;
        margin-bottom: 20px;
        font-size: 30px;
        border-radius: 10px;
      }
    }
    .typelist {
      width: 100%;
      background:#FFF;
      >div {
        >div {
          line-height: 80px;
          height: 100px;
          padding: 10px 25px;
          font-size: 28px;
          border-bottom: 1px solid #ebebeb;

          .van-field__label {
            width: auto;
            min-width: 140px;
            max-width: 220px;
            font-size: 26px;
          }

          .van-field__value {
            input {
              padding: 0 10px;
              font-size: 28px;
            }
          }

          .van-checkbox__icon {
            height: auto;

            .van-icon {
              width: 30px;
              height: 30px;
              font-size: 24px;
              margin-top: -6px;
            }
          }

          .van-checkbox__label {
            font-size: 28px;
            line-height: 30px;
          }

          &.van-checkbox {
            height: 90px;
            line-height: 70px;

            .van-checkbox__icon--checked .van-icon {
              background-color: #FFF;
              color: #f95d34;
              border-color: #f95d34;
            }
          }

          &.van-radio-groupBox {
            height: auto;
            padding: 20px 25px;

            h5 {
              font-size: 28px;
              line-height: 40px;
            }

            .van-radio-group {
              line-height: 50px;
              min-height: 40px;
              padding: 15px 0px 0px;

              .van-radio {
                margin: 0 20px 10px 0px;

                .van-radio__icon {
                  height: 40px;

                  .van-icon {
                    width: 30px;
                    height: 30px;
                    font-size: 24px;
                    margin: 5px 0px;
                  }
                }

                .van-radio__icon--checked .van-icon {
                  background-color: #FFF;
                  color: #f95d34;
                  border-color: #f95d34;
                }

                .van-radio__label {
                  font-size: 28px;
                  line-height: 30px;
                }
              }
            }

            .van-checkbox-group {
              line-height: 50px;
              min-height: 40px;
              padding: 15px 0px 0px;

              .van-checkbox {
                margin: 0 20px 10px 0px;

                .van-checkbox__icon {
                  height: 40px;

                  .van-icon {
                    width: 30px;
                    height: 30px;
                    font-size: 24px;
                    margin: 5px 0px;
                  }
                }

                .van-checkbox__icon--checked .van-icon {
                  background-color: #FFF;
                  color: #f95d34;
                  border-color: #f95d34;
                }

                .van-checkbox__label {
                  font-size: 28px;
                  line-height: 30px;
                }
              }
            }
          }

          &.van-check-time {
            height: auto;
            padding: 17px 25px;

            .van-cell {
              padding: 20px 0px;

              &::after {
                border: none;
              }
            }

            .van-cell__title {
              font-size: 28px;
            }

            .van-cell__value {
              font-size: 28px;
            }
          }

          &.van-select-groupbox {
            height: auto;
            padding: 10px 25px;
            display: flex;

            .van-select-label {
              -webkit-box-flex: 0;
              -webkit-flex: none;
              flex: none;
              box-sizing: border-box;
              width: auto;
              min-width: 140px;
              max-width: 200px;
              text-align: left;
              line-height: 78px;
              color: #646566;
              font-size: 26px;
            }

            .van-dropdown-menu {
              -webkit-box-flex: 1;
              flex: 1;

              .van-dropdown-menu__bar {
                line-height: 78px;
                height: 78px;
                margin: 0 10px;
                box-shadow: none;

                .van-dropdown-menu__title {
                  width: 100%;
                  text-align: center;

                  .van-ellipsis {
                    height: 78px;
                    line-height: 78px;
                    font-size: 28px;
                    max-width: 400px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin: 0 auto;
                  }

                  &::after {
                    border: 8px solid;
                    border-color: transparent transparent #dcdee0 #dcdee0;
                    top: 40%;
                    right: 0px;
                  }
                }

                .van-dropdown-menu__title--active {
                  color: #f95d34;
                }
              }

              .van-dropdown-item__option {
                font-size: 28px;
                height: 80px;
                line-height: 80px;
                padding: 10px 25px;

                .van-cell__title {
                  line-height: 60px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                .van-cell__value {
                  line-height: 60px;
                  width: 40px;
                  overflow: hidden;
                  flex: none;

                  .van-icon {
                    height: 60px;
                  }

                  .van-dropdown-item__icon {
                    color: #f95d34;
                  }
                }

                &.van-dropdown-item__option--active {
                  color: #f95d34;
                }
              }
            }
          }

          &.active {
            border-bottom: 1px solid #f95d34;

            .van-field__label,
            h5,
            .van-cell__title,
            .van-select-label {
              color: #ee0a24;
            }
          }
        }

        &:last-child {
          >div {
            border-bottom: none;
          }
        }
      }
    }
    .addPiaoBtnbox{
      width: 100%;
      margin: 30px auto;
      overflow: hidden;
      text-align: center;
      a,span{
        width: 200px;
        display: inline-block;
        height: 80px;
        line-height: 80px;
        border-radius: 10px;
        text-align: center;
        font-size: 30px;
        vertical-align: middle;
        margin: 0 30px;
      }
      .link{
        border: 2px solid #333;
      }
      .addPiaoBtn{
        background: #ed6b00;
        color: #FFF;
        border: 2px solid #ed6b00;
      }
    }
  }
</style>
